import React from 'react';
import { UsersCheckboxList } from './UsersCheckboxList';
import { UsersSearchField } from './UsersSearchField';
export const UsersSearchSelectField = ({ roles, permission, label, form, name, users, isLoading, required, rules, }) => {
    return (React.createElement(React.Fragment, null,
        label && React.createElement("p", { className: "mb-2 text-base" }, label),
        React.createElement(UsersSearchField, { roles: roles, permission: permission }),
        React.createElement(UsersCheckboxList, { name: name, users: users, form: form, isLoading: isLoading, required: required, rules: rules })));
};
